import { render } from "./PubgBoard.vue?vue&type=template&id=5f84eac1&scoped=true"
import script from "./PubgBoard.vue?vue&type=script&lang=js"
export * from "./PubgBoard.vue?vue&type=script&lang=js"

import "./PubgBoard.vue?vue&type=style&index=0&id=5f84eac1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f84eac1"]])

export default __exports__